import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import Icon, { iconSizeMap } from './Icon';
const Wrapper = styled.span<{ size: 'small' | 'medium' | 'large' }>`
  display: inline-block;
  height: ${({ size }) => iconSizeMap[size].icon};
  position: relative;
  width: ${({ size }) => iconSizeMap[size].icon};

  & svg {
    transition: fill 0.25s ease-in;
  }

  &:hover svg {
    fill: ${colors.smoke};
  }
`;
const Input = styled.input.attrs(() => ({
  type: 'checkbox',
}))`
  -webkit-appearance: button;
  cursor: pointer;
  height: inherit;
  left: 0;
  opacity: 0;
  padding: 0;
  position: absolute;
  margin: 0;
  top: 0;
  width: inherit;
`;
type Props = typeof Input & {
  startChecked: boolean;
  onChange?: (arg0: boolean) => void;
  size?: 'small' | 'medium' | 'large';
};
type State = {
  checked: boolean;
};

class CheckboxInput extends React.Component<Props, State> {
  static defaultProps = {
    size: 'medium',
  };
  state = {
    checked: this.props.startChecked || false,
  };

  render() {
    const { onChange, size, ...inputProps } = this.props;
    return (
      <Wrapper size={this.props.size || 'medium'}>
        <Icon size={size} icon={this.state.checked ? 'squareChecked' : 'squareOutlined'} />
        <Input
          checked={this.state.checked}
          onChange={ev => {
            const { checked } = ev.target;
            this.setState({
              checked,
            });
            onChange && onChange(checked);
          }}
          {...inputProps}
        />
      </Wrapper>
    );
  }
}

export default CheckboxInput;
